{
  "#CUSTOMER": {
    "TITLE": "Kundenabfrage",
    "SEARCH_PLACEHOLDER": "Kunde suchen – Name oder Kundennummer",
    "EMPTY": {
      "TITLE": "Kein Kunde ausgewählt",
      "DESCRIPTION": "Suchen Sie oben nach einem Kunden, um Kundeninfo, Kreditlimit, Umsatz und offene Posten zu sehen."
    }
  },
  "#UMSATZSTATISTIK": {
    "TITLE": "Umsatzstatistik"
  }
}
